import {useWorkstream} from 'views/workstreams/hooks';
import {isRestrictedWorkstreamAccessResponse} from 'views/workstreams/utils';
import {WorkstreamAccessRequest} from 'views/workstreams/WorkstreamAccessRequest';

import {WorkstreamScanList} from './WorkstreamScanList';
import {WorkstreamLoadFailure} from './WorkstreamsControls';

/**
 * /workstreams/:id: what a rail click shows. The workstream's card,
 * already open since it's alone (full update, metrics | milestones,
 * sub-workstreams as cards); its "More details" link goes on to the full page.
 */
export const WorkstreamFocus = ({
  workstreamId,
  onLeaveUpdate,
}: {
  workstreamId: number;
  onLeaveUpdate: (id: number) => void;
}) => {
  const {workstream, isLoading, error, refetch} = useWorkstream(workstreamId);

  if (isRestrictedWorkstreamAccessResponse(workstream as never)) {
    return (
      <WorkstreamAccessRequest
        requested={(workstream as {requested?: boolean | null}).requested ?? false}
        workstreamId={workstreamId}
      />
    );
  }
  if (!isLoading && !workstream) {
    return <WorkstreamLoadFailure error={error} onRetry={() => void refetch()} />;
  }

  return (
    <WorkstreamScanList
      workstreams={workstream ? [workstream] : []}
      loading={isLoading && !workstream}
      skeleton="card"
      onLeaveUpdate={onLeaveUpdate}
    />
  );
};
